import type {ThemeVariablesType} from '@yosmanyga/theme';
import {variables as baseVariables} from '@yosmanyga/fortaleza-core';

const variables: ThemeVariablesType = {
    ...baseVariables,
    widthing: (value: number) => {
        return value
    },
    font: (percent: string) => {
        return percent
    }
};

export {variables};